import { render, staticRenderFns } from "./AMXFormField.vue?vue&type=template&id=6d09dfd2&scoped=true&"
import script from "./AMXFormField.vue?vue&type=script&lang=ts&"
export * from "./AMXFormField.vue?vue&type=script&lang=ts&"
import style0 from "./AMXFormField.vue?vue&type=style&index=0&id=6d09dfd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09dfd2",
  null
  
)

export default component.exports